/**
 * A series' rhythm in a brass chip with the repeat mark, wherever a live that repeats is listed. How a live
 * repeats is picked in `RepeatPicker.tsx`.
 */
import type { ReactNode } from "react";
import "../styles/series.css";

export function RepeatChip({ children }: { children: ReactNode }) {
  return (
    <span className="repchip">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M17 2l4 4-4 4" />
        <path d="M3 11V9a3 3 0 013-3h15M7 22l-4-4 4-4" />
        <path d="M21 13v2a3 3 0 01-3 3H3" />
      </svg>
      {children}
    </span>
  );
}
